import React, { createContext, useState, useContext, type ReactNode } from 'react';

interface BuildingContextType {
  selectedBuilding: string | null;
  setSelectedBuilding: (buildingId: string | null) => void;
  selectedBuildingName: string | null;
  setSelectedBuildingName: (buildingName: string | null) => void;
}

const BuildingContext = createContext<BuildingContextType | undefined>(undefined);

interface BuildingProviderProps {
  children: ReactNode;
}

export const BuildingProvider: React.FC<BuildingProviderProps> = ({ children }) => {
  const [selectedBuilding, setSelectedBuilding] = useState<string | null>(null);
  const [selectedBuildingName, setSelectedBuildingName] = useState<string | null>(null);

  const value: BuildingContextType = {
    selectedBuilding,
    setSelectedBuilding,
    selectedBuildingName,
    setSelectedBuildingName,
  };

  return (
    <BuildingContext.Provider value={value}>
      {children}
    </BuildingContext.Provider>
  );
};

export const useBuilding = (): BuildingContextType => {
  const context = useContext(BuildingContext);
  if (context === undefined) {
    throw new Error('useBuilding must be used within a BuildingProvider');
  }
  return context;
};
